module.exports = __webpack_public_path__ + "static/media/navigation-drawer.ba64fc5b.svg";